import { DonorType } from '@/api/apis/case';
import { BloodSection } from './components/BloodSection';
import { CaseMatchSection } from './components/CaseMatchSection';
import { DonorDemographicsSection } from './components/DonorDemographicsSection';
import { HeartAdditionalInfoSection } from './components/HeartAdditionalInfoSection';
import { ParametersSection } from './components/ParametersSection';

type HeartDonorProfileFormProps = {
  donorType?: DonorType | null;
};

export const HeartDonorProfileForm = ({ donorType }: HeartDonorProfileFormProps) => (
  <div className="flex flex-col gap-6">
    <CaseMatchSection />
    <DonorDemographicsSection />
    <ParametersSection donorType={donorType} />
    <BloodSection />
    <HeartAdditionalInfoSection />
  </div>
);
